import { createLabeledMessages } from '../../../messageUtils';
const days = {
    monday: 'pondelok',
    tuesday: 'utorok',
    wednesday: 'streda',
    thursday: 'štvrtok',
    friday: 'piatok',
    saturday: 'sobota',
    sunday: 'nedeľa',
    monday_short: 'po',
    tuesday_short: 'ut',
    wednesday_short: 'str',
    thursday_short: 'štv',
    friday_short: 'pia',
    saturday_short: 'so',
    sunday_short: 'ne'
};
const months = {
    january: 'január',
    february: 'február',
    march: 'marec',
    april: 'apríl',
    may: 'máj',
    june: 'jún',
    july: 'júl',
    august: 'august',
    september: 'september',
    october: 'október',
    november: 'november',
    december: 'december'
};
const messages = Object.assign({}, days, months);
export default Object.assign({}, messages, createLabeledMessages(messages));
